import { useMediaQuery } from 'react-responsive';

export function useIsMobileView() {
  return useMediaQuery({ query: `(max-width: 760px)` });
}
